<template>
  <svg xmlns="http://www.w3.org/2000/svg" 
    :width="_width" 
    :height="_height"
    :spin="spin"
    :rtl="rtl"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    role="presentation"
    ref="host"
  >
    <g><defs><clipPath id="15c5df__a"><rect rx="0" height="24" width="24"/></clipPath></defs><g clip-path="url(#15c5df__a)"><g fill="#FF4B61"><path d="M6.037 3.5C3.532 3.5 1.5 5.58 1.5 8.147c0 4.646 5.362 8.87 8.25 9.853 2.887-.983 8.25-5.207 8.25-9.853C18 5.58 15.968 3.5 13.463 3.5c-1.535 0-2.892.78-3.713 1.974A4.501 4.501 0 0 0 6.037 3.5Z"/><path style="mix-blend-mode: passthrough" fill-rule="evenodd" d="M9.75 4.66q1.436-1.657 3.713-1.657 2.088 0 3.564 1.51 1.47 1.506 1.47 3.634 0 3.355-3.182 6.646-2.65 2.74-5.405 3.678-.16.054-.32 0-2.756-.938-5.405-3.678-3.182-3.29-3.182-6.646 0-2.128 1.47-3.633Q3.95 3.003 6.037 3.003 8.317 3 9.75 4.66Zm-3.712-.663q2.095-.001 3.302 1.759.052.076.128.128.082.056.179.077.096.02.194.002.097-.018.18-.072.083-.053.139-.135 1.209-1.759 3.303-1.759 1.67 0 2.852 1.211 1.188 1.217 1.188 2.939 0 2.953-2.903 5.955-2.403 2.486-4.85 3.371-2.446-.885-4.85-3.371Q1.997 11.1 1.997 8.147q0-1.722 1.188-2.939 1.182-1.21 2.853-1.21Z"/></g><path fill="#FF4B61" d="M12.916 9.24a3.64 3.64 0 0 0-3.647 3.632c0 3.632 4.31 6.934 6.631 7.702 2.321-.768 6.632-4.07 6.632-7.702a3.64 3.64 0 0 0-3.648-3.632c-1.233 0-2.324.61-2.984 1.543a3.648 3.648 0 0 0-2.984-1.543Z"/><path style="mix-blend-mode: passthrough" fill="#FFF" fill-rule="evenodd" d="M15.9 9.995q1.167-1.252 2.984-1.252 1.716 0 2.93 1.209 1.215 1.21 1.215 2.92 0 2.67-2.59 5.275-2.146 2.159-4.383 2.899-.156.051-.312 0-2.236-.74-4.383-2.899-2.59-2.604-2.59-5.275 0-1.71 1.215-2.92 1.214-1.21 2.93-1.21 1.819 0 2.985 1.253Zm-2.984-.257q1.637-.002 2.578 1.332.05.07.12.12.04.028.084.048.045.02.092.03.048.011.097.013.049 0 .097-.007.049-.009.094-.026.046-.018.087-.044.042-.026.077-.06.036-.033.064-.073.943-1.333 2.578-1.333 1.306 0 2.229.918.921.918.921 2.216 0 2.26-2.3 4.574-1.902 1.913-3.834 2.602-1.931-.69-3.833-2.602-2.301-2.313-2.301-4.574 0-1.298.922-2.216.923-.918 2.228-.918Z"/></g></g>
  </svg>
</template>

<script lang="ts">
import { Vue, prop } from 'vue-class-component';

class Props {
    width = prop<number | string>({
      type: [Number, String],
      required: false
    })
    
    height = prop<number | string>({
      type: [Number, String],
      required: false
    })
    
    stroke = prop<string>({
      type: String,
      required: false
    })
    
    fill = prop<string>({
      type: String,
      required: false
    })
    
    color = prop<string>({
      type: String,
      required: false
    })
    
    spin = prop<boolean>({
      type: Boolean,
      required: false
    })
    
    rtl = prop<boolean>({
      type: Boolean,
      required: false
    })
    

  // optional prop with default
  size = prop<number | string>({ default: '1em' })
}

export default class Shuangaixintianchong extends Vue.with(Props) {
    get _fill(): string | undefined {
        return this.fill || this.color
    }
    get _stroke(): string | undefined {
        return this.stroke || this.color
    }
    get _width(): string | number {
      return this.width || this.size
    }
    get _height(): string | number {
      return this.height || this.size
    }
  mounted():void {
        if (!this._fill) {
            (this.$refs.host as HTMLElement)?.querySelectorAll('[data-follow-fill]').forEach(item => {
            item.setAttribute('fill', item.getAttribute('data-follow-fill') || '')
            })
        }
        if (!this._stroke) {
            (this.$refs.host as HTMLElement)?.querySelectorAll('[data-follow-stroke]').forEach(item => {
            item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '')
            })
        }
    }
    updated():void {
        if (!this._fill) {
            (this.$refs.host as HTMLElement)?.querySelectorAll('[data-follow-fill]').forEach(item => {
            item.setAttribute('fill', item.getAttribute('data-follow-fill') || '')
            })
        }
        if (!this._stroke) {
            (this.$refs.host as HTMLElement)?.querySelectorAll('[data-follow-stroke]').forEach(item => {
            item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '')
            })
        }
    }
}
</script>

<style scoped>
svg[spin="true"] {animation: iconpark-spin 1s infinite linear;}

svg[spin="true"][rtl="true"] {animation: iconpark-spin-rtl 1s infinite linear;}

svg[rtl="true"] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% { -webkit-transform: rotate(0); transform: rotate(0);}

 100% {-webkit-transform: rotate(360deg); transform: rotate(360deg);}
}
@keyframes iconpark-spin-rtl {
  0% {-webkit-transform: scaleX(-1) rotate(0); transform: scaleX(-1) rotate(0);}

 100% {-webkit-transform: scaleX(-1) rotate(360deg); transform: scaleX(-1) rotate(360deg);}
}
</style>
